module.exports = __webpack_public_path__ + "static/img/16.e0c13bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/16.png
// module id = yXNs
// module chunks = 0